import { useState } from 'react';
import { usersAPI } from '@/lib/api';
import { useToast } from '@/hooks/use-toast';
import { getLocalizedErrorMessage } from '@/lib/error-i18n';
import i18n from '@/lib/i18n';

export const useProfile = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { toast } = useToast();

  const updateProfileVisibility = async (isProfilePublic: boolean) => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await usersAPI.updateProfileVisibility(isProfilePublic);

      if (response.success) {
        toast({
          title: i18n.t("common.success"),
          description: i18n.t("messages.profileVisibilityUpdated"),
        });
        return { success: true };
      } else {
        throw new Error(response.message || 'Failed to update visibility');
      }
    } catch (err: any) {
      const errorMessage = getLocalizedErrorMessage(err, 'errors.generic');
      setError(errorMessage);

      toast({
        title: i18n.t("common.error"),
        description: errorMessage,
        variant: "destructive",
      });

      return { success: false };
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    error,
    updateProfileVisibility,
  };
};
